import { JCRM_SOCKET, IMPOSIUM_SOCIAL_RENDER_TASK } from "utils/constants";

function normalizePositiveIntegerCreativeId(value) {
	if (value === undefined || value === null || value === "") {
		return null;
	}
	const parsed = Number(value);
	return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

function parseImposiumRenderMessage(message) {
	const data = message?.data || {};
	const task = typeof message?.task === "string" ? message.task : "";
	const status = typeof message?.status === "string" ? message.status : "";

	const creativeId = normalizePositiveIntegerCreativeId(data?.creativeId);

	return {
		isRenderTask: new RegExp(IMPOSIUM_SOCIAL_RENDER_TASK, "i").test(task),
		terminalRenderComplete: /complete|success/i.test(status),
		creativeId,
	};
}

function parseAfterEffectsRenderMessage(message) {
	const task = typeof message?.task === "string" ? message.task : "";
	const dataMessage =
		typeof message?.data?.message === "string" ? message.data.message : "";
	const blob = `${task} ${dataMessage}`.toLowerCase();
	const status = typeof message?.status === "string" ? message.status : "";

	const fromCreative = message?.data?.creative?.id ?? message?.data?.creativeId;
	let creativeId = normalizePositiveIntegerCreativeId(fromCreative);

	if (creativeId === null) {
		const dynamicMatch = /dynamic creative (\d+)/i.exec(blob);
		if (dynamicMatch) {
			creativeId = Number.parseInt(dynamicMatch[1]);
		}
	}
	if (creativeId === null) {
		const tailMatch = /creative (\d+) is complete/i.exec(blob);
		if (tailMatch) {
			creativeId = Number.parseInt(tailMatch[1]);
		}
	}

	return {
		isRenderTask: blob.includes("video render") && blob.includes("after effect"),
		terminalRenderComplete: /complete|success/i.test(status),
		creativeId,
	};
}

function makeRenderCompleteMatcher(parse) {
	return function isRenderCompleteMessage(message) {
		if (!message || message.origin !== JCRM_SOCKET) {
			return false;
		}
		const parsed = parse(message);
		return parsed.isRenderTask && parsed.terminalRenderComplete;
	};
}

function makeGetCreativeId(parse) {
	return function getCreativeIdFromRenderMessage(message) {
		return parse(message).creativeId;
	};
}

export const isImposiumVersionRenderCompleteMessage = makeRenderCompleteMatcher(parseImposiumRenderMessage);
export const getCreativeIdFromImposiumRenderMessage = makeGetCreativeId(parseImposiumRenderMessage);

export const isAfterEffectsVideoRenderCompleteMessage = makeRenderCompleteMatcher(parseAfterEffectsRenderMessage);
export const getCreativeIdFromAfterEffectsRenderMessage = makeGetCreativeId(parseAfterEffectsRenderMessage);

export const IMPOSIUM_RENDER_MATCHER = {
	isComplete: isImposiumVersionRenderCompleteMessage,
	getCreativeId: getCreativeIdFromImposiumRenderMessage,
};

export const AFTER_EFFECTS_RENDER_MATCHER = {
	isComplete: isAfterEffectsVideoRenderCompleteMessage,
	getCreativeId: getCreativeIdFromAfterEffectsRenderMessage,
};

export const DYNAMIC_RENDER_MATCHERS = [IMPOSIUM_RENDER_MATCHER, AFTER_EFFECTS_RENDER_MATCHER];
